<span class="caption text-ink-subtle font-normal inline-flex items-center gap-1">
	{{ translateKey | translate: translateParams }}
	@if (lowData) {
	<app-low-data-badge></app-low-data-badge>
	}
</span>
